import script from "./DraggableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DraggableItem.vue?vue&type=script&setup=true&lang=js"

import "./DraggableItem.vue?vue&type=style&index=0&id=229bca6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229bca6b"]])

export default __exports__